export enum TimeSuggestionsRequestState {
    NoSuggestionsFound = 1,
    SearchingSuggestions,
    ShowSuggestions,
}
